import Vue from 'vue'
import Router from 'vue-router'
import {
	isMobile
} from '@/../store/store';

const web = (name) => () => import(`@/views/web/${name}`);
const mobile = (name) => () => import(`@/views/mobile/${name}`);
const both = isMobile() ? mobile : web;

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
var routes = [{
		path: '/',
		name: '',
		component: both("Home"),
		children: [{
				path: '',
				component: both("index/index"),
				name: '首页'
			},
			{
				path: 'login',
				component: both("login"),
				name: '老师登录'
			},
			{
				path: 'index_login',
				component: both("index/Login"),
				name: '登录'
			},
			{
				path: 'index_register',
				component: both("index/register"),
				name: '注册'
			},
			{
				path: 'index_forgot_password',
				component: both("index/forgot_password"),
				name: '忘记密码'
			},
			{
				path: 'index_forgot_password_reset',
				component: both("index/forgot_password_reset"),
				name: '密码找回'
			},
			{
				path: 'course_index',
				component: both("course/index"),
				name: '课程'
			},
			{
				path: 'course_activity',
				component: both("course/activity"),
				name: '活动'
			},
			{
				path: 'course_activity_info',
				component: both("course/activity_info"),
				name: '活动详情'
			},
			{
				path: 'cart_activity',
				component: both("cart/activity"),
				name: '活动结算'
			},
			{
				path: 'course_search',
				component: both("course/search"),
				name: '课程索引'
			},
			{
				path: 'course_private',
				component: both("course/private"),
				name: '私教课'
			},
			{
				path: 'course_private_info',
				component: both("course/private_info"),
				name: '私教课详情'
			},
			{
				path: 'course_camps',
				component: both("course/camps"),
				name: '夏令营'
			},
			{
				path: 'course_camps_info',
				component: both("course/camps_info"),
				name: '夏令营详情'
			},
			{
				path: 'course_info',
				component: both("course/info"),
				name: '课程详情'
			},
			{
				path: 'course_competition',
				component: both("course/competition"),
				name: '竞赛'
			},
			{
				path: 'cart_index',
				component: both("cart/index"),
				name: '购物车'
			},
			{
				path: 'cart_settlement',
				component: both("cart/settlement"),
				name: '结算'
			},
			{
				path: 'payment_results',
				component: both("cart/payment_results"),
				name: '支付结果'
			},


			{
				path: 'news_index',
				component: both("news/index"),
				name: '社区'
			},
			{
				path: 'news_videos',
				component: both("news/videos"),
				name: '视频'
			},
			{
				path: 'news_info',
				component: both("news/info"),
				name: '社区详情'
			},
			{
				path: 'teachers_index',
				component: both("teachers/index"),
				name: '老师列表'
			},
			{
				path: 'teachers_info',
				component: both("teachers/info"),
				name: '老师列表详情'
			},
			{
				path: 'member_index',
				component: both("member/index"),
				name: '个人中心'
			},
			{
				path: 'member_courses',
				component: both("member/courses"),
				name: '我的课程'
			},
			{
				path: 'member_camp',
				component: both("member/camp"),
				name: '我的夏令营'
			},
			{
				path: 'member_private',
				component: both("member/private"),
				name: '我的私教课'
			},
			{
				path: 'member_orders',
				component: both("member/orders"),
				name: '订单'
			},
			{
				path: 'member_coupon',
				component: both("member/coupon"),
				name: '优惠券'
			},
			{
				path: 'member_orders_info',
				component: both("member/orders_info"),
				name: '订单详情'
			},
			{
				path: 'member_account',
				component: both("member/account"),
				name: '修改密码'
			},
			{
				path: 'member_friend',
				component: both("member/friend"),
				name: '邀请好友'
			},
			{
				path: 'member_credits',
				component: both("member/credits"),
				name: '学分'
			},
			{
				path: 'member_child',
				component: both("member/child"),
				name: '学生信息'
			},
			{
				path: 'virtual_index',
				component: both("virtual/index"),
				name: '虚拟班级'
			},
			{
				path: 'virtual_leave',
				component: both("virtual/leave"),
				name: '请假'
			},
			{
				path: 'virtual_mail',
				component: both("virtual/mail"),
				name: '站内信'
			},
			{
				path: 'virtual_mail_info',
				component: both("virtual/mail_info"),
				name: '站内信详情'
			},
			{
				path: 'virtual_teachers',
				component: both("virtual/teachers"),
				name: '老师交流'
			},
			{
				path: 'virtual_comment',
				component: both("virtual/comment"),
				name: '评分'
			},
			{
				path: 'virtual_task',
				component: both("virtual/task"),
				name: '作业'
			},
			{
				path: 'virtual_assess',
				component: both("virtual/assess"),
				name: '课堂评估'
			},
			{
				path: 'virtual_debate',
				component: both("virtual/debate"),
				name: '辩论评估'
			},
			{
				path: 'virtual_assess_history',
				component: both("virtual/assess_history"),
				name: '课堂评估历史'
			},
			{
				path: 'virtual_certificate',
				component: both("virtual/certificate"),
				name: '结业证书'
			},
			{
				path: 'virtual_feedback',
				component: both("virtual/feedback"),
				name: '意见反馈'
			},

			{
				path: 'member_information',
				component: both("member/information"),
				name: '资讯中心'
			},
			{
				path: 'member_information_info',
				component: both("member/information_info"),
				name: '资讯中心详情'
			},
			{
				path: 'member_edit',
				component: both("member/edit"),
				name: '设置'
			},
			{
				path: 'footer_about',
				component: both("footer/about"),
				name: '关于我们'
			},
			{
				path: 'footer_terms',
				component: both("footer/terms"),
				name: '法律法规'
			},
			{
				path: 'footer_team',
				component: both("footer/team"),
				name: '管理团队'
			},
			{
				path: 'footer_faq',
				component: both("footer/faq"),
				name: '常见问题'
			},
			{
				path: 'footer_contact',
				component: both("footer/contact"),
				name: '联系我们'
			},
			{
				path: 'footer_privacy',
				component: both("footer/privacy"),
				name: '隐私'
			},
			{
				path: 'footer_teacher_apply',
				component: both("footer/teacher_apply"),
				name: '教师申请'
			},
			{
				path: 'private_class_index',
				component: both("private_class/index"),
				name: '私教课虚拟班级'
			},
			{
				path: 'private_class_parent',
				component: both("private_class/parent"),
				name: '私教课虚拟班级家长交流'
			},
		],
	},
];
Vue.prototype.routes_data = routes;
export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js